import { mapBreakpoint, isResponsiveSpec, } from "../components/util/layoutconstants";
export function responsiveSpecToCss(spec, transformer) {
    return mapBreakpoint((item, key) => {
        return {
            [`@media (min-width: ${key[1].min}px)`]: Object.assign({}, revoSpecToCss(item, transformer)),
        };
    }, spec).reduce((acc, val) => (Object.assign(Object.assign({}, acc), val)), {});
}
export const revoSpecToCss = (spec, transformer) => {
    if (isResponsiveSpec(spec)) {
        return responsiveSpecToCss(spec, transformer);
    }
    else {
        return transformer(spec);
    }
};
//# sourceMappingURL=responsive.js.map